<script setup>
import { InitViewIDs } from '@src/config';
import { computed, onMounted, ref, watchEffect } from 'vue';

import { useViewportStateStore } from '../store/contours/viewport-state-store';
import { useCurrentStudyStore } from '../store/dicom-web/current-study-store';
import { useAppState } from '../store/ocg-app-state';
import SeriesThumbnailsOverlay from './SeriesThumbnailsOverlay.vue';
import VtkTwoView from './VtkTwoView.vue';

const currentStudyStore = useCurrentStudyStore();
const viewportStateStore = useViewportStateStore();
const appStateStore = useAppState();

const userInteractActiveViewer = computed(() => appStateStore.userActiveViewer);

const currentImageIndices = computed(() => {
  if (userInteractActiveViewer.value) {
    return viewportStateStore.getSelectedImageIndices(
      userInteractActiveViewer.value,
    );
  }
  return null;
});

const generalViewerViewID = ref(InitViewIDs.AnalysisGeneralView);

const selfIndices = computed(() => {
  return viewportStateStore.getSelectedImageIndices(generalViewerViewID.value);
});

const updateCrossRef = () => {
  viewportStateStore.clearReferenceImageUids(generalViewerViewID.value);

  if (!currentImageIndices.value || !currentImageIndices.value.seriesIdx)
    return;

  const sliceCount = currentStudyStore.getSliceCount(
    currentImageIndices.value.seriesIdx,
  );

  if (sliceCount <= 0) return;

  for (let i = 0; i < sliceCount; i++) {
    const imageId = currentStudyStore.getSliceImageUIDs(
      currentImageIndices.value.seriesIdx,
      i,
    )[0];
    viewportStateStore.addReferenceImage(
      generalViewerViewID.value,
      imageId,
      false,
    );
    if (i === currentImageIndices.value.sliceIdx) {
      viewportStateStore.setActiveReferenceImageUid(
        generalViewerViewID.value,
        imageId,
      );
    }
  }
};

onMounted(() => {
  updateCrossRef();
});

watchEffect(() => {
  if (
    userInteractActiveViewer.value
    || currentImageIndices.value
    || selfIndices.value
  ) {
    updateCrossRef();
  }
});
</script>

<template>
  <div class="column-container simple-panel">
    <div class="general-viewer-container">
      <VtkTwoView id="AnalysisGeneralView" title="General Purpose Viewer" />
    </div>
    <div class="thumbnails-container">
      <SeriesThumbnailsOverlay layout="horizontal" />
    </div>
  </div>
</template>

<style scoped>
.column-container {
  display: flex;
  padding: 6px;
  flex-direction: column;
  border-radius: 10px;
  gap: 5px;
  max-height: 100%;
}
.general-viewer-container {
  display: flex;
  justify-content: center;
  user-select: none;
  height: 45%;
  width: 400px;
  min-width: 400px;
}

.thumbnails-container {
  width: 100%;
  height: 55%;
  display: flex;
  justify-content: center;
}
</style>
